import { createContext, useCallback, useState } from 'react';

export const AppContext = createContext({});

export const AppContextProvider = ({ children }) => {
  const [context, setContext] = useState({});
  const [formFields, setFormFields] = useState([]);

  const updateContext = useCallback((value) => {
    setContext(() => setContext(value));
  }, []);

  const updateFormFields = useCallback((value) => {
    setFormFields(() => setFormFields(value));
  }, []);

  return (
    <AppContext.Provider
      value={{ context, updateContext, formFields, updateFormFields }}
    >
      {children}
    </AppContext.Provider>
  );
};
